import { Component, Inject, inject, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import AOS from 'aos';
import { isPlatformBrowser } from '@angular/common';
import { TrackingService } from '@shared/services/tracking.service';
import { CookieConsentService } from '@shared/services/cookies.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  route = inject(ActivatedRoute);

  constructor(
    private trackingService: TrackingService, 
    private cookieConsentService: CookieConsentService, 
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      if (isPlatformBrowser(this.platformId))
        this.saveParamsToLocalStorage(params);
    });
    if (isPlatformBrowser(this.platformId)) {
      (window as any).dataLayer = (window as any).dataLayer || [];
      (window as any).gtag = function() {
        (window as any).dataLayer.push(arguments);
      };
      (window as any).ttq = (window as any).ttq || { track: () => {} };
      (window as any).lintrk = (window as any).lintrk || { track: () => {} };

      // 👉 Subscribe to cookie consent changes
      this.cookieConsentService.consentChange$.subscribe((consent) => {
      this.trackingService.initializeTracking();

        // !! Sending analytics tracking without consent as requested by the marketing team - ENGI-580
        // if (consent?.analytics) {
        //   this.trackingService.initializeTracking();
        // }
      });
    }
  }

  saveParamsToLocalStorage(params) {
    if (
      params &&
      (params['utm_id'] ||
        params['utm_source'] ||
        params['utm_campaign'] ||
        params['utm_query'] ||
        params['utm_term'] ||
        params['utm_content'] ||
        params['source'] ||
        params['gclid'] ||
        params['fbclid'])
    ) {
      localStorage.setItem('campaignId', params['utm_id'] || null);
      localStorage.setItem('campaignSource', params['utm_source'] || null);
      localStorage.setItem('campaignName', params['utm_campaign'] || null);
      localStorage.setItem('campaignTerm', params['utm_term'] || null);
      localStorage.setItem('utm_query', params['utm_query'] || null);
      localStorage.setItem('utm_content', params['utm_content'] || null);
      localStorage.setItem('gclid', params['gclid'] || null);
      localStorage.setItem('fbclid', params['fbclid'] || null);
      localStorage.setItem('source', params['source'] || null);
    }
  }

  ngAfterViewInit(): void {
    // Initialize AOS (Animate On Scroll) library
    if (isPlatformBrowser(this.platformId)) {
      AOS.init({
        disable: () => window.innerWidth < 1024,
      });
    }
  }
}
